import { render, staticRenderFns } from "./OrganizationCreateLinkTeams.vue?vue&type=template&id=5fe9dd3e&scoped=true&"
import script from "./OrganizationCreateLinkTeams.vue?vue&type=script&lang=ts&"
export * from "./OrganizationCreateLinkTeams.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationCreateLinkTeams.vue?vue&type=style&index=0&id=5fe9dd3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe9dd3e",
  null
  
)

export default component.exports